import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { withAuthContext } from 'auth/AuthContext';
import { RouteProps } from 'react-router';

interface Props extends RouteProps {
  component: typeof React.Component | React.FunctionComponent<any>;
  isAuthenticated: boolean;
  exact?: boolean;
}

const ProtectedRoute = ({component, isAuthenticated, exact = false, ...rest}: Props) => {
  const Component = component; // JSX needs capital letter, lower case in props to keep it consistent with react-router
  return (
      <Route
        exact={exact}
        render={
          props =>
              isAuthenticated
                  ? <Component {...props} />
                  : <Redirect to='/login' />
        }
        {...rest}
      />
  );
};

export default withAuthContext(ProtectedRoute);
